module.exports = "pegasus/assets/theme2/small/2.jpg";